// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog__body[data-v-d7dc7a5c] {\r\n  padding: 15px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
